import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  allUpdatesAtom,
  crossAssociationTreeAtom,
  needingUpdateMatches,
  subTreeNodeIdMappingAtom,
} from './atoms'
import { INode } from 'shared/types/tree'
import React, { ReactElement, ReactNode } from 'react'
import { Column } from 'shared/ui/Table/types'
import { Box, Button } from '@mui/material'
import {
  CrossRefUpdateButtons,
  DeleteAllButton,
  GoToNode,
  UpdateAllButton,
} from './components'
import { Table } from 'shared/ui/Table/Table'
import { useToggleState } from 'shared/hooks'
import { nodeForId } from '../../utility/TreeHelpers'

export function MatchedTable() {
  const [useFiltered, toggleUseFiltered] = useToggleState(true)
  const fullTree = useAtomValue(crossAssociationTreeAtom)
  const matches = useAtomValue(subTreeNodeIdMappingAtom)
  const filteredMatches = useAtomValue(needingUpdateMatches)
  const updates = useAtomValue(allUpdatesAtom)

  const nodesFunc = (
    contentFunc: (n1: INode, n2: INode) => ReactElement | ReactNode,
  ) => {
    return ([id1, id2]: [string, string]) => {
      const node1 = fullTree && nodeForId(id1, fullTree)
      const node2 = fullTree && nodeForId(id2, fullTree)
      if (!node1 || !node2) return ''
      return contentFunc(node1, node2)
    }
  }

  const columns: Column<[string, string]>[] = [
    {
      title: 'Title',
      rowContent: nodesFunc((n1, n2) => {
        return (
          <Box>
            <Box>{n1.title}</Box>
            <Box>{n2.title}</Box>
          </Box>
        )
      }),
    },
    {
      title: 'Type',
      rowContent: nodesFunc((n1, n2) => {
        return (
          <Box>
            <Box>{n1.type}</Box>
            <Box>{n2.type}</Box>
          </Box>
        )
      }),
    },
    {
      title: 'Go',
      rowContent([n1, n2]: [string, string]) {
        return (
          <Box>
            <Box>
              <GoToNode nodeId={n1} />
            </Box>
            <Box>
              <GoToNode nodeId={n2} />
            </Box>
          </Box>
        )
      },
    },
    {
      title: 'Update',
      rowContent(param: [string, string]) {
        return <CrossRefUpdateButtons mapping={param} />
      },
    },
  ]

  return (
    <Table<[string, string]>
      title={`${matches.length} Matched ${updates.length} Will Be Updated`}
      columns={columns}
      items={useFiltered ? filteredMatches : matches}
      toolBarItems={[
        <Button key="uf" onClick={() => toggleUseFiltered()}>
          Use Filtered
        </Button>,
        <DeleteAllButton key="da" />,
        <UpdateAllButton key="ua" />,
      ]}
    />
  )
}
